import React, { useEffect } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

import Menu from "./Menu"
import Nav from "./Nav"
import HeaderPriceCalculator from "./HeaderPriceCalculator"

import IconContacts from "./icons/IconContacts"

export default () => {

    function useScrollDirection() {
        const [scrollDirection, setScrollDirection] = React.useState(null);

        React.useEffect(() => {
            let lastScrollY = window.pageYOffset;

            const updateScrollDirection = () => {
                const scrollY = window.pageYOffset;
                const direction = scrollY > lastScrollY ? "down" : "up";
                if (direction !== scrollDirection && (scrollY - lastScrollY > 5 || scrollY - lastScrollY < -5)) {
                    setScrollDirection(direction);
                }
                lastScrollY = scrollY > 0 ? scrollY : 0;
            };
            window.addEventListener("scroll", updateScrollDirection);
            return () => {
                window.removeEventListener("scroll", updateScrollDirection);
            }
        }, [scrollDirection]);

        return scrollDirection;
    }

    const scrollDirection = useScrollDirection();



    const data = useStaticQuery(graphql`
           query {
               wp {
                   rekord {
                       infoBanner {
                           infoActive
                           infoBannerText
                           infoUrl
                           infoUrlText
                           infoBannerColor
                       }
                   }
               }
           }
       `)

    const settings = data.wp.rekord.infoBanner

    return (
        <>
            <header className={
                scrollDirection === 'down' ?
                    "w-full sticky -top-48 z-50 transition-all duration-500" :
                    "w-full sticky top-0 left-0 z-50 transition-all duration-500"
            }>
                {settings.infoActive ?
                    <div className={settings.infoBannerColor === 'green' ? 'bg-rekord-green w-full z-10 text-white text-sm py-1 md:py-2 text-center' : 'bg-rekord-lorange w-full z-10 text-rekord-dorange text-sm py-1 md:py-2 text-center'}>
                        <div className="container mx-auto">
                            {settings.infoBannerText}
                            {settings.infoUrl && settings.infoUrl !== '' ?
                                <a href={settings.infoUrl} className={settings.infoBannerColor === 'green' ? 'text-rekord-white hover:text-rekord-white hover:opacity-75 transition-opacity duration-300 font-bold no-underline text-xs ml-2' : 'text-rekord-dorange hover:text-rekord-orange font-bold no-underline text-xs ml-2'} title={settings.infoUrlText}>
                                    → {settings.infoUrlText}
                                </a>
                                : ''}
                        </div>
                    </div>
                    : ''}
                <div className="bg-rekord-dgray block">
                    <div className="pl-4 md:pl-12">
                        <div className="flex justify-between items-center">

                            <Link className="" to="/" title="Rekord Fenster | Startseite">
                                <svg className="w-32 lg:w-44" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="130" height="23.392" viewBox="0 0 180 23.392">
                                    <defs>
                                        <clipPath id="clipPath">
                                            <path id="Clip_4" data-name="Clip 4" d="M0,0H179.5V22.23H0Z" fill="none" />
                                        </clipPath>
                                    </defs>
                                    <path id="Fill_1" data-name="Fill 1" d="M4.266,21.383H0V0H10.249a8.755,8.755,0,0,1,5.605,1.687,5.828,5.828,0,0,1,2.09,4.69A5.313,5.313,0,0,1,17.1,9.4a5.283,5.283,0,0,1-2.3,1.847A4.716,4.716,0,0,1,17.265,15.8v2.989a8.307,8.307,0,0,0,.517,2.588H13.449A5.8,5.8,0,0,1,13,19.039V15.773a2.568,2.568,0,0,0-.7-2.006,3.171,3.171,0,0,0-2.206-.643H4.266v8.258Zm0-17.594V9.457h6.079a4.56,4.56,0,0,0,1.872-.439,2.527,2.527,0,0,0,1.459-2.427c0-.693,0-2.8-3.427-2.8Z" transform="translate(55.192 0.525)" fill="#ffffff" />
                                    <path id="Fill_2" data-name="Fill 2" d="M16.618,21.382H0V0H16.391V3.79H4.266V8.35H14.614v3.789H4.266v5.453H16.618v3.79" transform="translate(76.755 0.524)" fill="#ffffff" />
                                    <g id="Group_9" data-name="Group 9">
                                        <path id="Clip_4-2" data-name="Clip 4" d="M0,0H179.5V22.23H0Z" fill="none" />
                                        <g id="Group_9-2" data-name="Group 9" clipPath="url(#clipPath)">
                                            <path id="Fill_3" data-name="Fill 3" d="M4.3,14.082v7.3H0V0H4.3V8.627L12.737,0h5.884L9.5,8.935,19.01,21.383H13.449L6.5,11.893,4.3,14.082" transform="translate(96.412 0.523)" fill="#ffffff" />
                                            <path id="Fill_5" data-name="Fill 5" d="M10.991,22.276a10.859,10.859,0,0,1-7.883-3.243A11.256,11.256,0,0,1,0,11.123,11.207,11.207,0,0,1,3.108,3.239,10.871,10.871,0,0,1,10.991,0a10.824,10.824,0,0,1,7.856,3.239,11.22,11.22,0,0,1,3.1,7.883,11.269,11.269,0,0,1-3.1,7.91A10.813,10.813,0,0,1,10.991,22.276Zm0-18.425C7.3,3.851,4.3,7.113,4.3,11.123c0,4.025,3,7.3,6.69,7.3,3.673,0,6.661-3.275,6.661-7.3A7.575,7.575,0,0,0,15.7,6,6.342,6.342,0,0,0,10.991,3.851Z" transform="translate(114.419 0)" fill="#ffffff" />
                                            <path id="Fill_6" data-name="Fill 6" d="M4.266,21.383H0V0H10.249a8.753,8.753,0,0,1,5.605,1.687,5.828,5.828,0,0,1,2.089,4.69A5.314,5.314,0,0,1,17.1,9.4a5.281,5.281,0,0,1-2.295,1.847A4.716,4.716,0,0,1,17.265,15.8v2.989a8.329,8.329,0,0,0,.517,2.588H13.45A5.77,5.77,0,0,1,13,19.039V15.773a2.568,2.568,0,0,0-.7-2.006,3.171,3.171,0,0,0-2.206-.643H4.266v8.258Zm0-17.594V9.457h6.079a4.561,4.561,0,0,0,1.872-.439,2.527,2.527,0,0,0,1.458-2.427c0-.693,0-2.8-3.426-2.8Z" transform="translate(139.506 0.525)" fill="#ffffff" />
                                            <path id="Fill_7" data-name="Fill 7" d="M8.311,21.382H0V0H8.311c6.242,0,10.12,4.1,10.12,10.69a11.049,11.049,0,0,1-2.757,7.8A9.843,9.843,0,0,1,8.311,21.382ZM4.269,3.79v13.8H8.311a5.183,5.183,0,0,0,4.83-2.5,9,9,0,0,0,1.022-4.437,8.406,8.406,0,0,0-1.119-4.613A5.246,5.246,0,0,0,8.311,3.79Z" transform="translate(161.068 0.524)" fill="#ffffff" />
                                            <path id="Fill_8" data-name="Fill 8" d="M51.036,21.222H28.768v-2.87H0L8.857,2.871H28.768V0H51.036V21.222ZM29.829,1.032V20.195h20.13V1.026H29.845v.006h-.015Zm18.2,17.321H40.89v-6.8h7.135v6.8Zm-9.11,0H31.762v-6.8h7.155v6.8Zm9.11-8.682H40.89V2.87h7.135v6.8Zm-9.109,0H31.762V2.87h7.155v6.8Z" transform="translate(-0.049 0.526)" fill="#ffffff" />
                                        </g>
                                    </g>
                                </svg>
                            </Link>

                            <div className="flex items-center">
                                <Menu className="hidden 2xl:inline-flex items-center justify-between gap-8 pr-12" />
                                <Nav scroll={scrollDirection} />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div className='fixed bottom-2 right-2 md:bottom-4 md:right-4 lg:bottom-8 lg:right-8 z-30'>
                <a href="#contact" title="Kontakt" className="flex flex-col items-center p-4 bg-rekord-green rounded-full shadow-lg">
                    <IconContacts w="36" h="36" />
                    <span className="sr-only">Kontakt</span>
                </a>
            </div>
        </>
    )
}
